import React from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import Form from 'apps/auth/components/form-multi/Form';
import { amplitudeEventForCompletedTopUp } from 'apps/auth/components/utils/AmplitudeUtils';
import BasePage from 'apps/auth/components/utils/BasePage';
import { topUpMethods } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { AMOUNT_TO } from 'apps/auth/constants/fieldsName';
import { TOP_UP_ACCOUNT } from 'apps/auth/constants/formName';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import { isObject } from 'apps/auth/helpers/utils';

import TopUpCalc from './TopUpCalc';

const TopUpByTrustly = (props) => {
    const submitHandler = (fields, data) => {
        if (Object.keys(data.errors).length === 0) {
            logInfo(data);
        }
    };

    return (
        <CommonPage backUrl={`/auth/ga/pocket/${props.id}/top-up`} leftCloseIcon hasBottomPanel>
            <TopUpCalc formName={TOP_UP_ACCOUNT} itemTitle={props.itemTitle} amountFieldName={AMOUNT_TO} />
            <Form
                formName={TOP_UP_ACCOUNT}
                getCanonicalPath={true}
                fields={props.fields}
                onSubmitHandler={submitHandler}
                action={`/auth/ga/pocket/${props.id}/top-up/trustly/pay.action`}
            >
                {isObject(props.fields) && (
                    <Row indent="adaptive-24-32">
                        {Object.values(props.fields).map((field) => {
                            return <InputAutoDetect key={field.name} formName={TOP_UP_ACCOUNT} field={field} />;
                        })}
                    </Row>
                )}

                <FixedBottomPanel>
                    <Button
                        type="submit"
                        raised={true}
                        disabled={props.amountFrom.isError || !props.amountFrom.value || parseFloat(props.amountFrom.value) === 0}
                        caption={props.cardTransferButton}
                        onClick={() => {
                            amplitudeEventForCompletedTopUp(topUpMethods.BANK_TRANSFER);
                        }}
                    />
                </FixedBottomPanel>
            </Form>
        </CommonPage>
    );
};
const mapStateToProps = (state) => {
    return {
        id: state.extra.id,
        account: state.extra.account,
        amountFrom: state.form[TOP_UP_ACCOUNT].fields[AMOUNT_TO],
        cardTransferButton: state.messages.pageMessages.cardTransferButton,
        itemTitle: state.messages.pageMessages.bankAccount,
    };
};

export default connect(mapStateToProps, {
    toggleModal,
})(BasePage(TopUpByTrustly));
